import LegalPage from "../components/LegalPage";
import { PRIVACY_SECTIONS, GALLERY } from "../data/content";

const Privacy = () => (
  <LegalPage
    testId="privacy-page"
    path="/privacy-policy"
    seoTitle="Privacy Policy"
    seoDescription="How BTK Mortgage Services handles your personal data — what we collect, how we use it, how long we keep it, and your rights."
    eyebrow="Legal · Privacy"
    title="Privacy policy."
    italic="How we handle your data."
    intro="A short, plain-English summary of what we collect, why, how long we keep it, and your rights."
    image={GALLERY[2]}
    sections={PRIVACY_SECTIONS}
  />
);

export default Privacy;
